<template>
  <section class="grid 1fr items-center justify-center justify-items-center">
    <div class="emptystate mb-40px"></div>
    <h2 class="text-skin-primary font-semibold text-l">
      No existen cursos disponibles
    </h2>
  </section>
</template>

<script>
export default {};
</script>

<style>
.emptystate {
  width: 400px;
  height: 400px;
  background-image: url("../assets/emptystate.png");
  background-size: contain;
  background-position: center;
}
</style>
